const popupInstances = new Map<string, Record<string, any>>()
const popupOpenedSet = new Set<string>()

export function usePopup() {
    const set = (selector: string, instance: Record<string, any>) => {
        popupOpenedSet.add(selector)
        popupInstances.set(selector, instance)
    }

    const has = (selector: string) => {
        return popupInstances.has(selector)
    }

    const isOpened = (selector: string) => {
        return !!$(selector).is(':visible')
    }

    const haveOpened = (selector: string) => {
        return popupOpenedSet.has(selector)
    }

    const openPopup = (selector: string, options?: Record<string, any>) => {
        const instance = $(selector).bPopup(options)
        popupInstances.set(selector, instance)
        popupOpenedSet.add(selector)
        return instance
    }

    const closePopup = (selector: string) => {
        const instance = popupInstances.get(selector)
        instance?.close?.()
        popupInstances.delete(selector)
    }

    const closePopupAll = () => {
        popupInstances.forEach((instance) => {
            try {
                instance?.close?.()
            } catch {
                // 已关闭的弹窗再次调用 close 会报错: Cannot read properties of null (reading 'onClose')
                // 为了避免通过非 closePopup / closePopupAll 关闭的弹窗再次调用 close 会报错所以使用 try-catch 处理此错误
            }
        })
        popupInstances.clear()
    }

    return {
        set,
        has,
        isOpened,
        haveOpened,
        openPopup,
        closePopup,
        closePopupAll,
    }
}
